module.exports = __webpack_public_path__ + "static/images/p1_grey.0fea1e4.png";